<div class="access-groups-filters">
  <app-search-box
    class="filters-search"
    [placeholder]="'userManagementPage.accessGroupsPage.filters.search' | labelsProvider"
    [startingValue]="pageFilters()?.search"
    (textOnSelection)="onSearchSubmitted($event)"
  >
  </app-search-box>
</div>
